/**
 * @packageDocumentation
 * @module f1/is
 */

export interface IsObject {
  /**
   * Is the value an object (any object); this is very permissive.
   *
   * @public
   * @see f1.is.record to detect a record, which is a `{}` object
   * @function f1.is.object
   * @example
   *
   * ```ts
   * f1.is.object(new Date()) => true
   * f1.is.object(/is-object/) => true
   *
   * f1.is.object(new Number(1)) => true
   * f1.is.object(1) => false
   * ```
   */
  (value: unknown): value is Record<string, unknown>;
}

/**
 * @see IsObject
 */
export default (value: unknown): value is Record<string, unknown> => {
  return Object(value) === value;
};
